"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useInterval = function (callback, interval) {
    var savedCallback = react_1.useRef(null);
    // After every render, save the latest callback into our ref.
    react_1.useEffect(function () {
        savedCallback.current = callback;
    });
    react_1.useEffect(function () {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        var id = setInterval(tick, interval);
        return function () { return clearInterval(id); };
    }, [interval]);
};
exports.default = useInterval;
